import React from 'react';

import { Brand, CityOrPlace, schema } from '@rover/components/src/microdata';
import A11yHiddenBox from '@rover/kibble/styles/A11yHiddenBox';
import type { CountryConfiguration } from '@rover/rsdk/src/apiClient/latest/model/countryConfiguration';
import type { SeoLocation } from '@rover/rsdk/src/apiClient/latest/model/seoLocation';

import SeoLocationHelmet from './SeoLocationHelmet';

const SeoLocationPageWrapper: React.FC<{
  seoLocation: SeoLocation;
  countryConfig: Pick<CountryConfiguration, 'urls'>;
  overrideTitle?: string;
  overrideMetaDescription?: string;
  children?: React.ReactNode;
}> = ({ seoLocation, countryConfig, overrideTitle, overrideMetaDescription, children }) => {
  return (
    <div itemScope itemType={schema`Service`}>
      <SeoLocationHelmet
        seoLocation={seoLocation}
        overrideTitle={overrideTitle}
        overrideMetaDescription={overrideMetaDescription}
      />

      <A11yHiddenBox>
        <CityOrPlace
          itemProp="areaServed"
          localityType={seoLocation.localityType}
          details={seoLocation.details}
        />
        <Brand itemProp="brand" indexUrl={countryConfig.urls.indexUrl} />
        <meta itemProp="category" content={seoLocation.details.titleCasedServiceKeyword} />
        <meta itemProp="serviceType" content={seoLocation.details.h1} />
        <meta itemProp="description" content={seoLocation.details.h2} />
        <meta itemProp="termsOfService" content={countryConfig.urls.tosUrl} />
      </A11yHiddenBox>
      {children}
    </div>
  );
};

export default SeoLocationPageWrapper;
